/**
 * class for a user
 */

export interface LoggedInUserInfo {
    welcomeMsg: string;
    account: any;
    filteredAccount: any;
    menu: any;
    publicAccount: boolean;
    accountPublicURL: string;
    accountControlDocument: any;
}
